import { cityFromGen, cityToGen } from "@/lib/seo-routes";

export interface FaqItem {
  q: string;
  a: string;
}

/**
 * Generuje listę typowych pytań dla strony wyników danej trasy.
 * Używane zarówno w UI (sekcja FAQ) jak i w JSON-LD (FAQPage schema.org).
 */
export function buildSearchFaq(opts: {
  fromCity: string;
  toCity: string;
  fromCode: string;
  toCode: string;
}): FaqItem[] {
  const { fromCity, toCity, fromCode, toCode } = opts;
  const fromGen = cityFromGen(fromCity);
  const toGen = cityToGen(toCity);
  return [
    {
      q: `Ile kosztuje lot z ${fromGen} do ${toGen}?`,
      a: `Ceny biletów z ${fromGen} (${fromCode}) do ${toGen} (${toCode}) zmieniają się dynamicznie i zależą od pory roku, dnia tygodnia oraz tego, jak wcześnie rezerwujesz. W naszej wyszukiwarce widzisz aktualne oferty od kilkudziesięciu linii lotniczych w jednym miejscu.`,
    },
    {
      q: `Kiedy najlepiej kupić bilet z ${fromGen} do ${toGen}?`,
      a: `Najtańsze bilety zwykle znajdziesz rezerwując 4–8 tygodni przed wylotem. Loty w środku tygodnia (wt./śr.) oraz poza wakacjami i długimi weekendami są przeważnie tańsze niż weekendowe.`,
    },
    {
      q: `Jakie linie lotnicze latają z ${fromGen} do ${toGen}?`,
      a: `Listę linii obsługujących trasę ${fromCode} → ${toCode} zobaczysz w filtrze „Linia lotnicza” nad wynikami. Możesz zawęzić wyniki do jednego przewoźnika lub porównać oferty różnych linii.`,
    },
    {
      q: `Czy mogę znaleźć tylko loty bezpośrednie?`,
      a: `Tak — użyj filtra „Bezpośrednie” w sekcji „Przesiadki” nad wynikami. Pokażemy wtedy wyłącznie loty bez przesiadki z ${fromCity} do ${toCity}.`,
    },
    {
      q: `Czy ceny zawierają bagaż?`,
      a: `Domyślnie pokazujemy ceny biletu wraz z bagażem podręcznym. Bagaż rejestrowany u tanich przewoźników jest często dodatkowo płatny — szczegóły zobaczysz po wybraniu konkretnej oferty.`,
    },
  ];
}
